import api from '../../api/client';
import React, { useEffect } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { BASE_URL } from '../../config/constant';

const AuthGuard = ({ children }) => {
    const account = useSelector((state) => state.account);
    const { isLoggedIn } = account;
    const location = useLocation();

    useEffect(() => {
        if (isLoggedIn) {
            const lastLocation = localStorage.getItem('lastLocation') || '/app/dashboard';
            if (lastLocation !== location.pathname) {
                localStorage.setItem('lastLocation', location.pathname);
            }
        }
    }, [isLoggedIn, location]);

    if (!isLoggedIn) {
        return (
            <Redirect
                to={{
                    pathname: '/auth/signin',
                    state: { from: location }
                }}
            />
        );
    }

    return children;
};

export default AuthGuard;


